import { css, html, LitElement } from "lit";

import { websiteStyles } from "../styles/website";

import "./discorduser";

import { isMobileDevice } from "../common/client";

export class FlightComponent extends LitElement {
  constructor() {
    super();

    /** @type {FlightSessionData} */
    this.flight = null;
  }

  static styles = [
    websiteStyles,
    css`
    
    .bubble {
        color: #fff;
        background-color: green;
        padding: 5px;
        border-radius: 5px;
        margin: 3px;
        text-transform: uppercase;
        display: inline-block;
        text-decoration: none;
        font-size: 0.7rem;
        font-weight: 600;
        vertical-align: middle;
      }
    `,
  ];

  render() {
    if (!this.flight) {
      return html``;
    }
    return html`<div class="row" style="cursor:default;">
      <div class="cell" style="min-width:80px;${isMobileDevice() ? "display:block;" : ""}">
        <span
          class="heading-uppercase"
          style="font-size: 12px;display:block;"
          >Flight</span
        >
        <span><a href="/flight/${this.flight.sessionId}">${this.flight.aircraftIcao}</a></span>
      </div>
      <div class="cell" style="min-width:100px;">
        <span
          class="heading-uppercase"
          style="font-size: 20px;${isMobileDevice() ? "display:block;margin-bottom:3px;" : ""}"
          >${this.flight.callsign || this.flight.aircraftIcao || this.flight.username} - ${Math.round(this.flight.distanceNm || 0).toLocaleString()} NM</span
        >${this.flight.active ? html` <div class="bubble">Active</div>` : ""}
      </div>
      <div class="cell stats">
        <span class="heading-uppercase" style="display:block;color:#CCC;font-size:12px;"
          >Started</span
        >
        <span>${`${new Date(this.flight.startedAt).toLocaleDateString()} ${new Date(this.flight.startedAt).toLocaleTimeString()}`}</span>
      </div>
      <div class="cell players">
        <discord-user-component .userID=${this.flight.userid}></discord-user-component>
      </div>
    </div>`;
  }
}

window.customElements.define("flight-component", FlightComponent);
